module.exports = __webpack_public_path__ + "static/media/INZ1198.7945d0f0.pdf";